<template>
  <v-list light dense expand v-if="listaMedicos.length !== 0 || listaFechas.length !== 0">
    <v-list-item >
      <span class="mr-4">Filtros</span> <v-chip class="ml-16" :disabled="!filtrar" filter-icon="mdi-notification-clear-all" label small v-model="filtrar" filter color="primary" @click="filterMedicos = []; filterFechas = []; filtrar = false">Mostrar todos</v-chip>
    </v-list-item>
    <v-list-group v-if="listaMedicos.length !== 0" :value="true">
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>Médicos</v-list-item-title>
        </v-list-item-content>
      </template>
      
      <v-list-item
        v-for="(medico,m) in listaMedicos" 
        :key="m"
      >
        <v-checkbox 
          v-model="filterMedicos" 
          hide-details="auto" 
          class="mt-0 pt-0"
          dense
          :label="medico.medico" 
          :value="medico.idMedico"
        ></v-checkbox>
      </v-list-item>
    </v-list-group>
    <v-divider></v-divider>
    <v-list-group v-if="listaFechas.length !== 0" :value="true">
      <template v-slot:activator>
        <v-list-item-content>
          <v-list-item-title>Fechas disponibles</v-list-item-title>
        </v-list-item-content>
      </template>
      <v-date-picker
        v-model="filterFechas"
        elevation="1"
        multiple
        :allowed-dates="allowedDates"
        class="mt-4 mb-4 mx-4"
        width="265"
        :min="listaFechas[0]"
        :max="listaFechas[listaFechas.length-1]"
        :events="turnos"
        event-color="green lighten-1"
        first-day-of-week="1"
      ></v-date-picker>
    </v-list-group>
    <v-divider></v-divider>
  </v-list>
</template>

<script>
  import {mapState, mapActions} from 'vuex'

  export default {
    data: () =>({
      filterMedicos: [],
      filterFechas: [],
      filtrar: false
    }),
    watch: {
      filterMedicos(){
        this.setMedicoFilters(this.filterMedicos)
        if(this.filterMedicos.length !== 0){
          this.filtrar = true
        }else if(this.filterFechas.length === 0){
          this.filtrar = false
        }
      },
      filterFechas(){
        this.setFechaFilters(this.filterFechas)
        if(this.filterFechas.length !== 0){
          this.filtrar = true
        }else if(this.filterMedicos.length === 0){
          this.filtrar = false
        }
      }
    },
    computed: {
      ...mapState('turnos',[
        'listaTurnos',
        'listaMedicos',
        'listaFechas',
        'listaMisTurnos',
        'fechaFilters',
        'medicoFilters',
      ]),
      turnos(){
        let misTurnos =  []
        misTurnos = this.listaMisTurnos.map(turno => turno.event.start.toISOString().substr(0,10))
        return misTurnos
      }
    },
    methods: {
      ...mapActions('turnos',[
        'setMedicoFilters',
        'setFechaFilters'
      ]),
      allowedDates(val){
        return this.listaFechas.includes(val)
      },
      
    },
    mounted(){
      if(this.fechaFilters.length !== 0){
        this.filterFechas = this.fechaFilters.map(fecha => fecha)
      }
      if(this.medicoFilters.length !== 0){
        this.filterMedicos = this.medicoFilters.map(medico => medico)
      }
    }
  }
</script>